import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import { addNewGatesData, deleteGates, fetchGatesList, updateGates } from "../thunks/gatesThunks";

import type { Gates } from "../../utils/types/gates";


interface GatesListState {
  gatesList: Gates[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}
const initialState: GatesListState = {
  gatesList: [],
  loading: false,
  error: null,
  isDataFetched: false,

};

export const gatesListSlice = createSlice({
  name: "gatesList",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGatesList.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
        state.error = null;
      })
      .addCase(fetchGatesList.fulfilled, (state, action) => {
        state.gatesList = action.payload;
        state.loading = false;
      })
      .addCase(fetchGatesList.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });
    builder
      .addCase(updateGates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGates.fulfilled, (state, action) => {
        state.loading = false;
        const payloadAny = action.payload as any;
        const updatedGate: Gates | null = payloadAny && payloadAny.data ? payloadAny.data : payloadAny;
        if (updatedGate) {
          const gid = (updatedGate as any).gate_id || (updatedGate as any).id || null;
          if (gid) {
            state.gatesList = state.gatesList.map((gates: Gates) =>
              gates?.gate_id === gid ? { ...gates, ...updatedGate } : gates
            );
          }
        }
      })
      .addCase(updateGates.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Unknown error… Please try again";
      });

    builder
      .addCase(deleteGates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteGates.fulfilled, (state, action) => {
        state.loading = false;
        state.gatesList = state.gatesList.filter(
          (gates) => gates.gate_id !== action.payload.id
        );
      })
      .addCase(deleteGates.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewGatesData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewGatesData.fulfilled, (state, action) => {
        state.loading = false;
        state.gatesList=[action.payload,...state.gatesList]
      })
      .addCase(addNewGatesData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
      addWebSocketCases(builder, "gates", "gatesList");
  },
});

export const { resetDataFetched } = gatesListSlice.actions;
export default gatesListSlice.reducer;
